import React from 'react'
import PropTypes from 'prop-types'
import StatusDot from '../IssueStatuses/StatusDot'
import Text from '../../ui/Text'

const percentOf = (count, total) => {
  if (!total)
    return 0
  return Math.min(100, count / total * 100)
}

const StatusProgressRow = ({ name, color, count, total }) => (
  <div className="tw:flex tw:items-center tw:gap-1.5 tw:w-full">
    <div className="tw:flex tw:items-center tw:gap-1 tw:flex-1 tw:min-w-0">
      <StatusDot color={color} />
      <span className="tw:flex-1 tw:min-w-0">
        <Text className="tw:block tw:text-xs tw:text-gray-500" truncate>{name}</Text>
      </span>
    </div>
    <div className="tw:flex-1 tw:min-w-0 tw:max-w-44">
      <div className="tw:h-1.5 tw:w-full tw:bg-gray-100 tw:rounded-full">
        <div
          className="tw:h-full tw:bg-neutral-500 tw:rounded-full"
          style={{ width: `${percentOf(count, total)}%` }}
        />
      </div>
    </div>
    <div className="tw:w-6 tw:shrink-0 tw:flex tw:justify-end tw:text-xs tw:text-gray-500">
      {count}
    </div>
  </div>
)

StatusProgressRow.propTypes = {
  color: PropTypes.string,
  count: PropTypes.number,
  name: PropTypes.string,
  total: PropTypes.number
}

StatusProgressRow.defaultProps = {
  color: null,
  count: 0,
  name: '',
  total: 0
}

export default StatusProgressRow
